module.exports = __webpack_public_path__ + "img/banner.4a486579.jpg";